import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathRef = useRef<string>('');

  useEffect(() => {
    // Vérifier si on vient de fermer une DetailCard
    // Si le chemin précédent avait plus de segments que le chemin actuel,
    // cela signifie probablement qu'on ferme un détail pour revenir à la liste
    const prevPathSegments = prevPathRef.current.split('/').filter(Boolean);
    const currentPathSegments = pathname.split('/').filter(Boolean);
    
    const isClosingDetail = prevPathSegments.length > currentPathSegments.length && 
                           currentPathSegments.length === 1;
    
    // Vérifier si c'est la page d'accueil ou une section principale (premier accès)
    const isHomeOrMainSection = pathname === '/' || 
                              (currentPathSegments.length === 1 && !isClosingDetail);

    if (isHomeOrMainSection) {
      // Forcer le scroll à 0 uniquement pour la homepage et les sections principales
      // mais pas quand on ferme un détail
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      // Utiliser requestAnimationFrame pour s'assurer que le scroll est appliqué
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      });
    }
    
    // Mettre à jour le chemin précédent pour la prochaine navigation
    prevPathRef.current = pathname;
  }, [pathname]);

  return null;
};